module.exports = __webpack_public_path__ + "media/12.ccde2eaf.wav";